"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveRoomListPopUp = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../../common");
const server_1 = require("../../../../server");
const account_1 = require("../../account");
const funtions_1 = require("../../../DST/DSTT001/funtions");
const popup_1 = require("../../popup");
const LiveRoomListPopUpWrapper = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    gap: 12px;

    .live-room-list-title {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: 16px 0;
        gap: 4px;
    }

    .title-count {
        font-size: 20px;
        font-weight: 700;
        line-height: 32px;
        letter-spacing: -0.02em;
    }

    .room-count {
        color: #f46790;
    }

    .title-guide {
        font-size: 16px;
        font-weight: 400;
        line-height: 32px;
        letter-spacing: -0.02em;
        color: var(--color-grey, #666666);
    }

    .live-room-list {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 100%;
        overflow-y: auto;
    }

    .room-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 12px 0;
        gap: 4px;
        border-bottom: 1px solid var(--color-silver, #f3f4f8);
    }

    .room-details {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: 100%;
        gap: 4px;
    }

    .room-title {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: -0.02em;
    }

    .room-detail {
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: -0.02em;
        color: var(--color-grey-l, #83868a);
    }

    .reservation-btn {
        padding: 0;
        width: 60px;
        height: 26px;
        p {
            font-size: 12px;
            line-height: 22px;
        }
    }
`;
const LiveRoomListPopUp = ({ allowedConferenceIds, allowedTypes, titleText, guideText, 
// 정렬 기준(서버 orderby). 기본은 Live 입장 팝업의 기존 동작(시작시각 오름차순).
// 테스트 응시 팝업은 테스트 리스트와 동일하게 등록일 최신순(creation_time DESC)을 넘긴다.
orderby = ['startline ASC'], }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const [roomList, setRoomList] = (0, react_1.useState)([]);
    const { data, refetch } = (0, server_1.useConferenceList)({
        status: ['held', 'booked'],
        ...(allowedTypes && allowedTypes.length > 0 ? { type: allowedTypes } : {}),
        orderby,
    });
    (0, react_1.useEffect)(() => {
        refetch();
    }, [isTeacher]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { total_count, items, server_time } = data;
            if (total_count > 0) {
                const filteredByAllowList = allowedConferenceIds && allowedConferenceIds.length > 0
                    ? items.filter(item => allowedConferenceIds.includes(item.id))
                    : items;
                const filteredItemsByType = allowedTypes && allowedTypes.length > 0
                    ? filteredByAllowList.filter(item => allowedTypes.includes(item.type))
                    : filteredByAllowList;
                if (isTeacher) {
                    setRoomList(filteredItemsByType);
                }
                else {
                    const now = new Date(server_time).getTime();
                    const filteredItems = filteredItemsByType.filter((item) => {
                        if (item.status === "held")
                            return true;
                        const startTime = new Date(item.start_time).getTime();
                        const preEnteringTime = item.pre_entering_duration * 60 * 1000;
                        return now >= startTime - preEnteringTime && now <= startTime;
                    });
                    setRoomList(filteredItems);
                }
            }
            else {
                setRoomList([]);
            }
        }
    }, [data, isTeacher, allowedConferenceIds, allowedTypes]);
    function formatDateTime(dateTime) {
        const date = new Date(dateTime);
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
    }
    const renderTitle = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement("div", { className: "live-room-list-title" },
            react_1.default.createElement("div", { className: "title-count" },
                titleText || t('conference.availableRooms'),
                " ",
                react_1.default.createElement("span", { className: "room-count" }, roomList.length),
                " ",
                t('conference.availableRoomsSuffix')),
            react_1.default.createElement("div", { className: "title-guide" }, guideText || t('conference.selectRoomToEnter'))));
    }, [roomList, titleText, guideText, t]);
    const renderList = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement("div", { className: "live-room-list" }, roomList.map((item, index) => (react_1.default.createElement("div", { className: "room-item", key: index },
            react_1.default.createElement("div", { className: "room-details" },
                react_1.default.createElement("div", { className: "room-title" }, item.title),
                react_1.default.createElement("div", { className: "room-detail" }, (() => {
                    const startDate = new Date(item.start_time);
                    const endDate = new Date(startDate.getTime() + item.progress_duration * 60 * 1000);
                    const sameDay = startDate.toDateString() === endDate.toDateString();
                    const pad = (n) => String(n).padStart(2, '0');
                    const endStr = sameDay
                        ? `${pad(endDate.getHours())}:${pad(endDate.getMinutes())}`
                        : formatDateTime(endDate.toISOString());
                    return `${formatDateTime(item.start_time)} ~ ${endStr} (${item.pre_entering_duration}${t('conference.beforeMinute')} ${t('common.enter')})`;
                })()),
                react_1.default.createElement("div", { className: "room-detail" }, item.host_name)),
            react_1.default.createElement(common_1.Button, { className: "reservation-btn", text: t('common.enter'), onClick: () => (0, funtions_1.goToConference)(item.id) }))))));
    }, [roomList, t]);
    const closePopup = () => APP.eventManager.publish(popup_1.TOGGLE_POPUP, undefined);
    return (react_1.default.createElement(LiveRoomListPopUpWrapper, null,
        renderTitle,
        renderList,
        react_1.default.createElement(common_1.Button, { text: t('common.cancel'), className: "btn_white xmd", onClick: closePopup })));
};
exports.LiveRoomListPopUp = LiveRoomListPopUp;
